define('views/components/distributor_role/distributor_role_list',['require','views/base/list_view','views/components/distributor_role/distributor_role','text!templates/components/distributor_role/distributor_role_list.html'],function(require){

    var BaseListView = require('views/base/list_view');
    var ChildView = require('views/components/distributor_role/distributor_role');

    var temp = require("text!templates/components/distributor_role/distributor_role_list.html");
    return BaseListView.extend({
        template: _.template(temp),
        childView: ChildView
    });
});

